import { type ReactNode } from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';

import { type TFunction } from '@/modules/localisation/helper';

type RenderAccordionContentParams = {
  t: TFunction;
  contentKey: string;
  linkUrl?: string;
  className?: string;
};

export function renderAccordionContent({
  t,
  contentKey,
  linkUrl,
}: RenderAccordionContentParams) {
  const content = t.rich(contentKey, {
    a: (children: ReactNode) => (
      <a href={linkUrl} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
    p: (children: ReactNode) => <Body variant="sm-regular">{children}</Body>,
    ul: (children: ReactNode) => <ul>{children}</ul>,
    li: (children: ReactNode) => <li>{children}</li>,
  });

  return content;
}
